<ng-template #contentHeaderTemplate>
  <div class="row">
    <div class="col-12 d-flex justify-content-end ">
      <button class="btn btn-primary" routerLink="/administration/emails/add">
        {{ 'authenticated.administration.emails.create_btn' | translate }}
      </button>
    </div>
  </div>
</ng-template>

<app-table id="dashboard.administration.emails.index"></app-table>
